<template>
  <div id="zt8211">
    <div id="k1">
      <div>
        <label>ZT8211 Android Portable Data Collector</label>
        <label>25 degree scan angle, easily scanning and  comfortably reading.</label>
        <span>
          <!-- <img :src="require('@/assets/pic/zt8211/icons.png')" /> -->
        </span>
      </div>
      <!-- <img :src="require('@/assets/pic/zt8211/bgcv1.png')" /> -->
    </div>
    <div id="k2">
      <div>
        ZT8211 is a updated generation of Android intelligent terminal with high performance and wide application fields, with gold curve and anti-slide corrugated line design. Integrate data acquisition, wireless communication, camera, GPS and other functions, etc.. Adapt to various industries and scenarios.
      </div>
    </div>
    <div id="k3">
      <div>High quality capacitive touch</div>
      <div>Support dry and wet hands, with or without glove fingertip touch, adapt harsh environment as rain, snow, dust, etc. </div>
    </div>
    <div id="k4">
      <div>Fast Scan and Upload</div>
      <div>WiFi , 2G/3G/4G, Bluetooth</div>
    </div>
    <div id="k5">
      <h5>Application scenarios</h5>
      <div v-for="item in asdata" :key="item.label">
        <img :src="item.pic" />
        <label>{{item.label}}</label>
      </div>
    </div>

    <pdspecs :data="$store.state.iscn?spdata:spdata_en"></pdspecs>
  </div>
</template>

<script>
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    // var _this = this
    return {
      asdata: [
        {
          label: 'Convenient Store',
          pic: require('@/assets/pic/zt8211/as1.jpg')
        },
        {
          label: 'Logistics',
          pic: require('@/assets/pic/zt8211/as2.jpg')
        },
        {
          label: 'Restaurant',
          pic: require('@/assets/pic/zt8211/as3.jpg')
        }
      ],
      spdata: {
        file: 'zt8211',
        data: [
          {label: '通讯接口', desc: ['RJ45接口×1', 'USB-B接口×1'], pic: 'port.png'},
          {label: '输入电压', desc: ['DC5V±5%'], pic: 'char.png'},
          {label: '按键数量', desc: ['数字按键×10', '功能按键×6'], pic: 'keyt.png'},
          {label: '可扩充性（选配）', desc: ['扩展功能键盘(扫描方式1×4)'], pic: 'expand.png'},
          {label: '算法支持', desc: ['DES、Triple DES（3DES）、RSA','SHA-256、SM2、SM3、SM4'], pic: 'safe.png'},
          {label: '功能支持', desc: ['PIN加密、MAC运算、数据加密/解密、远程密钥管理、远程固件更新'], pic: 'funsp.png'},
          {label: '符合标准', desc: ['ANSI X、ISO、IBM3624、GB/T 15277以及国密标准GM/T等'],pic: 'stdok.png'},
          {label: '安全特性', desc: ['产品表面防水、防尘、防拆、防钻、防置换，键盘被非法移除或拆解时，键盘中的敏感信息就会自毁。'], pic: 'safegd.png'},
          {label: '保护能力', desc: ['停电敏感数据可保存7年以上'],pic: 'prtab.png'},
          {label: '按键压力', desc: ['2N~5.5N'], pic: 'bpress.png'},
          {label: 'IK防护等级 level', desc: ['IK08'],pic: 'prtlv.png'},
          {label: '防水等级 level', desc: ['静态IP65', '动态IP54'],pic: 'prtw.png'},
          {label: '按键材料', desc: ['SUS304'], pic: 'keymt.png'},
          {label: 'EFT', desc: ['能通过重复频率100KHz，', '电压1.0KV抗干扰测试'],pic: 'eft.png'},
          {label: 'ESD', desc: ['可承受接触放电±6KV、', '空气放电±8KV的静电攻击'],pic: 'esd.png'},
          {label: 'Environment', desc: ['工作温度：-25℃～+60℃', '存储温度：-40℃～+70℃', '相对湿度：10%～93% RH (无凝结露)'], pic: 'env.png'}
        ]
      },
      spdata_en: {
        file: 'zt8211',
        data: [
          {label: 'CPU', desc: ['Quad-core 2.0GHz CPU'], pic: 'cpu.png'},
          {label: 'Memory', desc: ['2GB RAM + 16GB ROM '], pic: 'ram.png'},
          {label: 'OS', desc: ['Android 9.0'], pic: 'sys.png'},
          {label: 'Screen', desc: ['3.5”FWVGA, 854x480 Pixel'], pic: 'disp.png'},
          {label: 'Camera', desc: ['8 Megapixel'], pic: 'face.png'},
          {label: 'Touch', desc: ['Multi-point PCAP','(Projective Capacitive Touch)'],pic: 'touch.png'},
          {label: 'Wireless', desc: ['GSM: 900/1800 MHz', 'WCDMA: 2100 MHz'], pic: 'mobi.png'},
          {label: 'WI-FI', desc: ['802.11 b/g/n/ac'], pic: 'wifi.png'},
          {label: 'Bluetooth', desc: ['BT5.0,v3.0+HS/V4.2 LE'], pic: 'blt.png'},
          {label: 'Location', desc: ['GPS/APS/GCONASS/GALILEO'], pic: 'lbs.png'},
          {label: 'Laser Safety', desc: ['IEC 62471/IEC60825'], pic: 'safe.png'},

          {label: 'Accessories', desc: ['Adapter, Cable, handstrap, Charging Cradle, 4-slot battery charger.'], pic: 'part.png'},

          {label: 'Scanner', desc: ['iQR，PDF417，DataMatrix，MaxiCode etc. Code 39，Codabar， Code 128，Discrete 2 of 5，UPC，EAN，MSI etc.'], pic: 'scan.png'},
          {label: 'Port', desc: ['Type-C USB'], pic: 'port.png'},
          {label: 'Keypad', desc: ['Number keysx10','Function keysx14'], pic: 'keyb.png'},
          {label: 'Battery ', desc: ['Expected Battery Life Talking 20 Hours', 'Expected Battery Life Standby 500 Hours', '4.2V/4000mAh'], pic: 'battery.png'},
          {label: 'Dimensions', desc: ['169(L)x72(W)x23.8(H) mm'], pic: 'size.png'},
          {label: 'Environment', desc: ['Operating Temperature：-20℃~+55℃', 'Storage Temperature：-30℃~+70℃', 'Humidity: 5%~95%', 'Sealing : IP64'], pic: 'env.png'}
        ]
      }
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zt8211 {
  background: black;
  margin-top: -.93rem;
}
#k1 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8211/bg1.jpg');
  background-size: 100% 100%;
  overflow: hidden;
  box-sizing: border-box;
  color: #FFFFFF;
  padding-top: .7rem;
}
#k1 div {
  display: inline-block;
  vertical-align: top;
  margin-top: 1.75rem;
  margin-left: 3.72rem;
  width: 7.09rem;
}
#k1 label {
  display: block;
  font-size: .6rem;
  font-weight: 400;
}
#k1 label:nth-child(2) {
  font-size: .36rem;
  font-weight: 300;
  margin-top: .1rem;
}


#k2 {
  background: #2E2D2C;
  text-align: center;
  height: 1.78rem;
  overflow: hidden;
  box-sizing: border-box;
  font-size: .24rem;
  font-weight: 400;
  color: #FFFFFF;
  text-align: center;
}

#k2 div {
  width: 12.18rem;
  margin: .41rem auto;
}

#k3 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8211/bg2.jpg');
  background-size: 100% 100%;
  color: white;
  overflow: hidden;
  padding-left: 3.46rem;
}
#k3 div:nth-child(1) {
  margin-top: 2.47rem;
  font-weight: bold;
  font-size: .6rem;
  font-weight: 400;
  color: #666666;
}
#k3 div:nth-child(2) {
  width: 8.1rem;
  font-size: .36rem;
  font-weight: 350;
  color: #666666;
  margin-top: .1rem;
}

#k3 img {
  width: 2.7rem;
  height: 3.89;
  margin-left: 8.4rem;
}

#k4 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8211/bg3.jpg');
  background-size: 100% 100%;
  overflow: hidden;
  color: #666666;
  text-align: center;
}
#k4 div:nth-child(1) {
  font-size: .6rem;
  font-weight: 400;
  margin: .58rem auto;
}
#k4 div:nth-child(2) {
  font-size: .36rem;
  font-weight: 400;
  color: #666666;
  width: 6.2rem;
  margin: -.45rem auto;
}

#k5 {
  height: 7rem;
  background:#FAFAFA ;
  text-align: center;
  overflow: hidden;
}
#k5 h5 {
  font-size: .6rem;
  font-weight: bold;
  color: #313333;
  margin: .75rem auto .52rem auto;
}
#k5 div {
  display: inline-block;
  margin: 0 .1rem 0 .1rem;
}
#k5 img {
  display: block;
  height: 2.62rem;
  margin-bottom: .34rem;
}
#k5 label {
  font-size: .32rem;
  font-weight: bold;
  color: #0080CC;
}




</style>
